import { useEffect } from "react";
import WebsocketEventer from "../utils/websockets/WebsocketEventer";

export const useKeepAliveGenSocket = (wsSocket: WebsocketEventer | null) => {
  useEffect(() => {
    console.debug("wsSocket", wsSocket);
    console.debug("wsSocket.isOpened()", wsSocket && wsSocket.isOpened());

    if (wsSocket) {
      const keepAliveIntervals = setInterval(() => {
        console.debug("useKeepAliveGenSocket");
        /**
         * Keep alive is for bypassing cloudflare 100 secs of timeout after idle
         * we ping at a random time every 40-60 seconds
         */
        wsSocket &&
          wsSocket.isOpened() &&
          wsSocket.send({
            kind: "CONTROL",
            job: "CON_PING",
          });
      }, Math.floor(40 + Math.random() * 20 * 1000)); // random number between 40-60
      return () => clearInterval(keepAliveIntervals);
    }
  }, [wsSocket]);
};
